import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import NavBar from "../Navigation/NavBar";
import Footer from "../Footer/Footer";
import WhatsAppWidgetComponent from "../Whatsapp/WhatsAppWidgetComponent";
import "./Careers.css";

function Careers() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="careers-page">
      <NavBar />
      <section className="careers-hero" aria-labelledby="careers-heading">
        <div className="hero-content">
          <p className="career-eyebrow">CAREERS AT QUAREC RESOURCES</p>
          <h1 id="careers-heading">Careers at Quarec Resources</h1>
          <p className="subtitle">
            Current vacancies can change. Contact the recruitment team to
            confirm whether a role is active and request the latest job
            description before applying. This page does not advertise
            unverified or guaranteed openings.
          </p>
          <a className="apply-btn" href="mailto:career4@quarec.com?subject=Current%20vacancy%20enquiry">
            Ask about current vacancies
          </a>
        </div>
      </section>
      <main className="career-content-wrap">
        <section aria-labelledby="before-apply-heading" className="career-guidance-card">
          <h2 id="before-apply-heading">Before you apply</h2>
          <p className="career-intro">
            Ask for enough information to decide whether a role is suitable.
            A genuine vacancy should have a clear role title, duties, location,
            employment type and recruitment process.
          </p>
          <ul>
            <li>Confirm the job title, responsibilities, location and required experience.</li>
            <li>Ask about employment terms and compensation details before accepting an offer.</li>
            <li>Verify the recruiter and employer through contact details you can independently confirm.</li>
            <li>Share only the information needed for the current stage of an application.</li>
          </ul>
        </section>
        <section className="career-how-to-apply" aria-labelledby="apply-heading">
          <h2 id="apply-heading">How to enquire or apply</h2>
          <ol>
            <li>Contact the recruitment team and confirm that the vacancy is open.</li>
            <li>Request the full job description and the next steps.</li>
            <li>If you have been asked to apply, use the <Link to="/ApplyJob">application form</Link> and enter the exact role title, or follow the instructions provided by the verified recruiter.</li>
          </ol>
          <p>
            Recruitment enquiries: <a href="mailto:career4@quarec.com">career4@quarec.com</a>.
          </p>
          <p>
            Do not pay an unexpected advance fee or share one-time passcodes,
            bank PINs or unnecessary identity documents before verifying the
            employer and the reason for the request. Visa and work-authorisation
            decisions are made by the relevant authorities; check current
            requirements through official channels.
          </p>
          <p>
            You can also read our <Link to="/Resources/Offer-Checklist">job-offer verification checklist</Link> or review the <Link to="/Privacypolicy">Privacy Policy</Link>.
          </p>
        </section>
      </main>
      <Footer />
      <WhatsAppWidgetComponent />
    </div>
  );
}

export default Careers;
